import Link from "next/link";
import React, { useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Pagination, Autoplay } from "swiper/modules";
import Innerhtml from "../utils/Innerhtml";
import SeriesCard from "../utils/SeriesCard";

export default function TestseriesSection({ data, centers }) {
  const defaultProduct = data?.advanceData?.data || "";

  const [filteredData, setFilteredData] = useState(defaultProduct);
  const [activeId, setActiveId] = useState(null);

  const handleData = (id) => {
    setActiveId(id);
    // console.log(id);
    const filterProduct = defaultProduct.filter(
      (item) => item.course?.id === id
    );
    setFilteredData(filterProduct);
  };

  // console.log("filterTestSeries",filterTestSeries)
  // console.log("filteredData",filteredData)

  return (
    <>
      {/* {JSON.stringify(filteredData)} */}
      <div className="testseries ">
        <section className=" pt-12">
          {/* Top Navigation Buttons */}
          <div className="container">
            {data?.advanceData?.course?.length > 0 && (
              <div className="flex flex-wrap justify-evenly gap-8 mb-12">
                {data?.advanceData?.course.map((item, ind) => (
                  <button
                    onClick={() => handleData(item.id)}
                    key={ind}
                    className={`px-7 py-1 rounded-xl text-xl font-bold transition-all border shadow-[0px_4px_10px_rgba(0,0,0,0.3)]
                  ${
                    activeId === item.id
                      ? "bg-yellow-500 border-yellow-600 text-[#EEFBFF] scale-103"
                      : "bg-[#FFD338] border-black text-gray-900 hover:bg-yellow-400"
                  }
                `}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            )}

            {/* Main Heading */}
            <div className="text-center my-16">
              {data?.heading && (
                <h2 className="text-5xl lg:text-[68px] font-bold text-[#000000] mb-4">
                  {data.heading}
                </h2>
              )}
              {data?.subHeading && (
                <h3 className="text-lg lg:text-[36px] text-[#000000] font-[500]  mx-auto leading-snug">
                  {data?.subHeading.split("||")[0]}
                  <br />
                  {data?.subHeading.split("||")[1]}
                </h3>
              )}
            </div>
          </div>

          {filteredData.length > 0 ? (
            <div className="container">
              <Swiper
                className="w-full toppers-slider"
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                
                pagination={{
          
                  clickable: true,
                }}
                observer={true}
                observeParents={true}
                modules={[
                  // Pagination,
                  Autoplay,
                ]}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 12,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                  },
                  640: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                  },
                  768: {
                    slidesPerView: 2.3,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3.3,
                    spaceBetween: 20,
                  },
                  1280: {
                    slidesPerView: 3.3,
                    spaceBetween: 24,
                  },
                  1536: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                  },
                }}
              >
                {filteredData.map((series, index) => (
                  <SwiperSlide key={index}>
                    {/* <div
                    key={index}
                    className={` rounded-2xl p-6 shadow-lg border-2 border-gray-200 h-full flex flex-col `}
                  >
                    <div className="text-center ">
                      <h3 className="xl:text-[22.66px] text-base font-bold text-[#000000] mb-1">
                        {series?.name}
                      </h3>
                      <p className="xl:text-[11.33px] text-[10px] text-[#666] mb-4">
                        {series?.course?.name}
                      </p>

                      <div
                        className={`mb-2 ${
                          series?.linkedProduct?.category ===
                          "5b47f7ef1e899567332d1d0a"
                            ? "bg-[#FFF7EB]"
                            : "bg-[#FFD338]"
                        }  py-3  px-3 rounded-md flex items-center  gap-1 mb-1`}
                      >
                        <span className="lg:text-[28.99px] text-xl font-medium text-gray-900">
                          <sup className="lg:text-[16.19px] text-sm mx-1">
                            ₹
                          </sup>
                          {series?.cost}
                        </span>
                        <span className="text-sm lg:text-[17.81px] text-start font-[400] text-gray-700">
                          {series?.linkedProduct?.category ===
                          "5b47f7ef1e899567332d1d0a"
                            ? "Online Test Series"
                            : "Offline Test Series"}
                        </span>
                      </div>
                    </div>

                    <div className="flex-grow mb-6">
                      <div className="max-h-80 overflow-y-auto pr-2 custom-scroll px-3">
                        <ul className="space-y-3">
                          <li className="flex items-start space-x-2">
                    
                            <Innerhtml data={series?.desci} />
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="mt-auto">
                      {series?.linkedProduct?.category ===
                      "5b47f7ef1e899567332d1d0a" ? (
                        <>
                          <Link
                            href={`/courses/details/${series?.linkedProduct.uri}`}
               
                            className="w-full bg-yellow-400 inline-block lg:text-[18.19px] text-sm hover:bg-yellow-500 text-gray-900  text-center py-3 px-4 rounded-lg font-bold mb-4 transition-colors"
                          >
                            Buy Now
                        
                          </Link>

                          <Link
                            href="https://play.google.com/store/apps/details?id=in.clclive.app"
                            target="_blank"
                            className="w-full bg-yellow-400 inline-block lg:text-[16.19px] text-sm hover:bg-yellow-500 text-gray-900 py-3 px-4 rounded-lg font-medium mb-4 transition-colors"
                          >
                            Download{" "}
                            <span className="text font-[800]">
                              CLC Live App
                            </span>
                          </Link>
                          <div className="flex justify-center md:space-x-6 space-x-2">
                            <Link
                              href="https://play.google.com/store/apps/details?id=in.clclive.app"
                              target="_blank"
                            >
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                alt="Google Play Store"
                                className=" h-8 w-auto cursor-pointer hover:opacity-80 transition-opacity"
                              />
                            </Link>
                            <Link
                              href="https://apps.apple.com/in/app/clc-live-for-iit-jee-and-neet/id6737020863"
                              target="_blank"
                            >
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                                alt="App Store"
                                className=" h-8 w-auto cursor-pointer hover:opacity-80 transition-opacity"
                              />
                            </Link>
                          </div>
                        </>
                      ) : (
                        <div className="text-center">
                          <div className=" rounded-lg p-3 ">
                            <div className="text-sm bg-[#EAEAEA] py-3 px-4 rounded-lg w-full text-[16.91px] font-medium text-gray-900 mb-2">
                              Offline Test Centers
                            </div>
                          </div>
                          <p className="text-[14.57px] text-[#000000] leading-relaxed">
                            SIKAR • KOTA • JAIPUR • ALWAR • BIKANER • JODHPUR •
                            NARNAUL • DELHI
                          </p>
                        </div>
                      )}
                    </div>
                  </div> */}

                    <SeriesCard series={series} centers={centers} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ) : (
            <div className="text-center py-8 font-bold text-4xl">
              Available Soon...
            </div>
          )}
        </section>
      </div>
    </>
  );
}
